import { AuthConfig, OAuthStorage } from 'angular-oauth2-oidc';
import { CrossTabOauth2Storage } from 'src/app/digigov/store/cross-tab-oauth2-storage';
import { DgEncryptOuth2Storage } from 'src/app/digigov/store/dg-encrypt-oauthstorage';

import * as uuid from 'uuid';
export const randomString = (length) => {
  let result = '';
  const characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    const numArr = new Uint8Array(1);
    const randomNumArr = window.crypto.getRandomValues(numArr);
    result += characters.charAt(randomNumArr[0] * charactersLength);
  }
  return result;
};

export const getDeviceId = () => {
  if (!localStorage.getItem('device_id')) {
    let str1 = uuid.v4();
    let str2 = randomString(10);
    let device_id = str1 + '-' + str2;
    localStorage.setItem('device_id', JSON.parse(JSON.stringify(device_id)));
  }
  return localStorage.getItem('device_id');
};

export const authCodeFlowConfig: AuthConfig = {
  // Url of the Identity Provider
  // This will be come from env.json
  issuer: 'https://10.10.98.57:9444/oauth2/token',

  // URL of the SPA to redirect the user to after login
  redirectUri: window.location.origin,

  postLogoutRedirectUri: window.location.origin,

  // URL of the SPA to redirect the user after silent refresh
  //silentRefreshRedirectUri: window.location.origin + '/silent-refresh.html',

  // The SPA's id. The SPA is registerd with this id at the auth-server

  //clientId: 'QgNHubTX9Jfy1kflYUiPK7JCNrQa',
  // This will be come from env.json
  clientId: "B9pKWq2M5ClGonUYNyncr0c50LAa",

  // Just needed if your auth server demands a secret. In general, this
  // is a sign that the auth server is not configured with SPAs in mind
  // and it might not enforce further best practices vital for security
  // such applications.
  // dummyClientSecret: 'secret',

  responseType: 'code',

  // set the scope for the permissions the client should request
  // The first four are defined by OIDC.
  // Important: Request offline_access to get a refresh token
  // The api scope is a usecase specific one
  //scope: 'openid email offline_access device_' + getDeviceId(),
  // This will be come from env.json
  scope: null,

  showDebugInformation: true,

  requestAccessToken: true,

  strictDiscoveryDocumentValidation: false,

  // This will be come from env.json
  requireHttps: true,
};


export const customOauth2Config = {
  allowedResourceServerUrls: ['http://10.10.98.57:8280/digigov/v1'],
  //storageType: localStorage | sessionStorage
  storageType: localStorage,
  refreshTokenEnabled: true,
  //refreshTokenType: 'auto' | 'custom',
  refreshTokenType: 'custom',
};

